import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-report\">\n<style type=\"text/css\">\n\t#icon-report .st0{fill:#333333;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M38,8h-6c-0.2-1.7-1.7-3-3.4-3h-9c-1.8,0-3.2,1.3-3.4,3h-6c-2.8,0-5,2.3-5,5V38c0,2.8,2.3,5,5,5H38\n\t\tc2.8,0,5-2.3,5-5V13C43,10.3,40.7,8,38,8z M19,8.5C19,8.2,19.2,8,19.5,8h9C28.8,8,29,8.2,29,8.5v2c0,0.3-0.2,0.5-0.5,0.5h-9\n\t\tc-0.3,0-0.5-0.2-0.5-0.5V8.5z M40,38c0,1.1-0.9,2-2,2H10c-1.1,0-2-0.9-2-2V13c0-1.1,0.9-2,2-2h6c0.2,1.7,1.7,3,3.4,3h9\n\t\tc1.8,0,3.2-1.3,3.4-3h6c1.1,0,2,0.9,2,2V38z\" />\n\t<path class=\"st0\" d=\"M32.4,21.4l-6.6,6.6l-2-3.4c-0.2-0.4-0.6-0.7-1.1-0.7c-0.5-0.1-0.9,0.1-1.2,0.4l-8,8c-0.6,0.6-0.6,1.5,0,2.1\n\t\tc0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l6.6-6.6l2,3.4c0.2,0.4,0.6,0.7,1.1,0.7c0.5,0.1,0.9-0.1,1.2-0.4l8-8\n\t\tc0.6-0.6,0.6-1.5,0-2.1C34,20.9,33,20.9,32.4,21.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/report.svg
// module id = PzDz
// module chunks = 35